import React, { useContext, useEffect, useState } from 'react';
import { Drawer, Button, Col, Row, Typography } from 'antd';
import ParseHTML from 'html-react-parser';

import { ThemeContext } from '../Context/ThemeContext';
import Parser from '../Card/Parser';
import getFontSize from '../../Assets/Utilities/FontSize';
import getDrawerHeight from '../../Assets/Utilities/DrawerHeight';

const { Text, Paragraph } = Typography;

const PreviewUpdate = (props) => {
  const {
    visible = false,
    onClose = () => {},
    item = {},
    onAction = () => {},
  } = props;

  const { theme } = useContext(ThemeContext);

  return (
    <div>
      <Drawer
        width='100%'
        height={`${getDrawerHeight(item.description.length)}%`}
        onClose={onClose}
        visible={visible}
        placement='bottom'
        headerStyle={{ background: theme.drawer.bg }}
        bodyStyle={{
          background: theme.drawer.bg,
        }}
        footerStyle={{ background: theme.drawer.bg }}
        maskStyle={{ background: theme.drawer.bg, opacity: '0.95' }}
        closable={false}
        title={
          <div>
            <Text
              style={{
                color: theme.content.text,
                fontSize: `14px`,
              }}
              type='secondary'
            >
              Preview Mode &nbsp;&bull;&nbsp;
              {new Date(item.createdAt).toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              })}{' '}
              &nbsp;&bull;&nbsp;
              {new Date(item.createdAt).toDateString()}
            </Text>
          </div>
        }
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button
              type='ghost'
              onClick={onClose}
              style={{ marginRight: 8, color: theme.drawer.text }}
            >
              Close
            </Button>
            <Button type='primary' onClick={onAction}>
              Take Action
            </Button>
          </div>
        }
      >
        <Row>
          <Col xs={0} sm={0} md={4} lg={6} />
          <Col xs={24} sm={24} md={16} lg={12}>
            <Paragraph
              style={{
                color: `${theme.content.text}`,
                fontSize: getFontSize(item.description.length),
                transform: 'wrap',
              }}
            >
              {ParseHTML(Parser(`${item.description}`))}
            </Paragraph>
          </Col>
          <Col xs={0} sm={0} md={4} lg={6} />
        </Row>
      </Drawer>
    </div>
  );
};

export default PreviewUpdate;
